<template>
    <div class="wl-assistance-stu">
        <img :src="topbg" alt="" class="top-image">
        <div class="stu-info-content clearfix">
            <div class="info-left">
                <img src="https://file.clpp.org.cn/66ykt/gen/D31450BF31B5A7D4E13B0D1A25AB2360/1.png" alt="">
                <div class="btn-download" @click="clickPdf">
                    点击查看全部内容
                </div>
            </div>
            <div class="info-middle">
                <div class="middle-top-table clearfix">
                    <h3 class="h3-title-top">毕业生就业情况统计表</h3>
                    <div class="entrance-left clearfix">
                        <img :src="qiye" alt="" class="left-icon-img">
                        <div class="btn-entrance" @click="qiyeEn">企业入口 <i class="wl-icon-zhedie"></i></div>
                    </div>
                    <div class="entrance-right clearfix">
                        <img :src="yuanxiao" alt="" class="left-icon-img">
                        <div class="btn-entrance bg-btn" @click="schoolEn">院校入口 <i class="wl-icon-zhedie"></i></div>
                    </div>
                </div>
                <div class="bottom-company-info">
                    <div class="hader-top">主办单位</div>
                    <ul>
                        <li><i class="dian"></i>中国物流与采购联合会</li>
                        <li><i class="dian"></i>全国物流职业教育教学指导委员会</li>
                    </ul>
                    <div class="hader-top" style="margin-top: 15px">落实单位</div>
                    <ul>
                        <li>
                            <i class="dian"></i>全国物流职业教育教学指导委员会秘书处
                        </li>
                        <li><i class="dian"></i>中国物流与采购联合会教育培训部</li>
                        <li><i class="dian"></i>冷链物流专业委员会医药物流分会</li>
                        <li><i class="dian"></i>同城即时物流分会</li>
                        <li><i class="dian"></i>电商商务物流与快递分会</li>
                        <li><i class="dian"></i>服装物流分会</li>
                        <li><i class="dian"></i>汽车物流分会</li>
                        <li><i class="dian"></i>危化品物流分会</li>
                        <li><i class="dian"></i>物流与供应链人力资源专委会（筹）</li>
                    </ul>
                </div>
            </div>
            <div class="info-right">
                <h3 class="h3-title-tops">企业招聘信息</h3>
                <div class="hader-top">
                    <span style="width: 30%;">企业名称</span>
                    <span>岗位名称</span>
                    <span>需求数量</span>
                    <span>需求省份</span>
                </div>
                <div class="data-info">
                    <vue-seamless-scroll :data="dataList" :class-option="classOption" class="seamless-warp">
                        <div class="data-info-li" v-for="(item,index) in dataList" :key="index">
                            <span style="width: 30%;">{{item.CompanyName}}</span>
                            <span>{{item.JobsName}}</span>
                            <span>{{item.NeedNumber}}</span>
                            <span>{{item.NeedProvince}}</span>
                        </div>
                    </vue-seamless-scroll>
                </div>
                <!-- <div class="btn-download" @click="download">
                    <i class="wl-icon-xiazai"></i>
                    下载查看全部内容
                </div> -->
                <div class="btn-download" @click="checkAllList">
                    <!-- <i class="wl-icon-xiazai"></i> -->
                    查看全部内容
                </div>
            </div>
        </div>
        <div class="bottm-back">
            <img :src="bottombg" alt="" class="bottom-back-img">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            topbg: require('assets/images/stu-top.png'),
            bottombg: require('assets/images/stu-bottom.png'),
            yuanxiao: require('assets/images/yuanxiao.png'),
            qiye: require('assets/images/qiye.png'),
            dataList:[],
            // dataList: [
            //     {
            //         name: '广州顺丰速运有限公司',
            //         post: '收派员',
            //         count: '50'
            //     },
            //     {
            //         name: '广州顺丰速运有限公司',
            //         post: '仓管员',
            //         count: '20'
            //     },
            //     {
            //         name: '广州顺丰速运有限公司',
            //         post: '客服代表',
            //         count: '10'
            //     },
            //     {
            //         name: '广州顺丰速运有限公司',
            //         post: '运作员',
            //         count: '20'
            //     },
            //     {
            //         name: '广州顺丰速运有限公司',
            //         post: '营业点文员',
            //         count: '20'
            //     },
            //     {
            //         name: '顺丰速运有限公司',
            //         post: '收派员',
            //         count: '1000'
            //     },
            //     {
            //         name: '顺丰速运有限公司',
            //         post: '仓管员',
            //         count: '500'
            //     },
            //     {
            //         name: '顺丰速运有限公司',
            //         post: '客服代表',
            //         count: '700'
            //     },
            //     {
            //         name: '顺丰速运有限公司',
            //         post: '运作员',
            //         count: '500'
            //     },
            //     {
            //         name: '顺丰速运有限公司',
            //         post: '营业点文员',
            //         count: '100'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '仓库操作员岗',
            //         count: '150'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '仓库操作员岗',
            //         count: '50'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '快运/分拣操作员岗',
            //         count: '70'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '快运/分拣操作员岗',
            //         count: '30'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '快递员',
            //         count: '50'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '快递员',
            //         count: '50'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '仓储龙腾计划（储干）',
            //         count: '40'
            //     },
            //     {
            //         name: '京东华东区',
            //         post: '仓储龙腾计划（储干）',
            //         count: '40'
            //     },
            // ]
        }
    },
    created(){
        this.getJobsList();
    },
    computed:{
        classOption() {
            return {
                direction: 1,
                hoverStop: true,
                step: 0.8,
            };
        },
    },
    methods:{
        qiyeEn(){
            window.open('http://www.clppx.org.cn/enterpriseStatic');
        },
        schoolEn(){
            window.open('http://www.clppx.org.cn/schoolStatic');
        },
        clickPdf(){
            window.open('https://file.clpp.org.cn/66ykt/ori/dfqgacgpxkvh2z39w5cdqq/ibCj7fFPDYhXhYYG.pdf');
        },
        download(){
            window.location.href = 'https://file.clpp.org.cn/ykt/ori/4b2kaocod71etmbe7h4mja/eZr7NGDkBYYEwzQ7.xlsx?response-content-disposition=attachment;filename=疫情期间支持企业复工复产、职业院校毕业生就业创业有关统计表-物流20200422-v1.xlsx';
        },
        checkAllList(){
            this.$router.push({
                name: "jobsNeedList",
                params: {
                }
            });
        },
        getJobsList(){
            var that = this;
            this.$http
            .post("/api/XOrg/JobsNeedAllList/getAllJobsList", {
            })
            .then(rst => {
            if (rst.code == 1) {
                this.dataList = rst.list;
            } else {
                this.$message.warning(rst.msg);
            }
            });
        }
        
    }
}
</script>

<style lang="scss">
.wl-assistance-stu{
    .top-image{
        width: 100%;
    }
    .stu-info-content{
        width: 1200px;
        margin: -120px auto 0;
        position: relative;
    }
    .info-left{
        float: left;
        width:382px;
        height:564px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 27px 0px rgba(132,132,132,0.14);
        position: relative;
        img{
            width: 100%;
        }
        .btn-download{
            position: absolute;
            bottom: 0;
            line-height: 33px;
            color: #fff;
            font-size: 14px;
            width: 100%;
            text-align: center;
            background: rgba(0,0,0,0.36);
            cursor: pointer;
        }
    }
    .info-middle{
        float: left;
        margin-left: 13px;
        .middle-top-table{
            width:410px;
            height:160px;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 27px 0px rgba(132,132,132,0.14);
            padding-top: 20px;
            padding-left: 0px;
            box-sizing: border-box;
        }
        .entrance-left{
            margin-top: 26px;
            margin-left: 30px;
            float: left;
            width:162px;
            height:68px;
            background:linear-gradient(162deg,rgba(254,158,123,1) 0%,rgba(246,129,85,1) 100%);
            border-radius:4px;
            padding: 17px 10px;
            box-sizing: border-box;
        }
        .entrance-right{
            margin-top: 26px;
            float: left;
            padding: 17px 10px;
            width:162px;
            height:68px;
            background:linear-gradient(162deg,rgba(81,168,252,1) 0%,rgba(69,132,241,1) 100%);
            border-radius:4px;
            box-sizing: border-box;
            margin-left: 26px;
        }
        .left-icon-img{
            float: left;
        }
    }
    .h3-title-top{
        font-size: 16px;
        color: #59657A;
        font-weight: bold;
        font-family:Source Han Sans SC;
        text-align: center;
        position: relative;
        padding-bottom: 7px;
    }
    .h3-title-tops{
        font-size: 16px;
        color: #59657A;
        font-weight: bold;
        font-family:Source Han Sans SC;
        text-align: center;
        position: relative;
        padding-bottom: 7px;
    }
    .btn-entrance{
        float: left;
        padding: 7px 0px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 16px 2px rgba(247,116,67,0.52);
        opacity:0.84;
        border-radius:14px;
        width: 88px;
        text-align: center;
        color: #FC956F;
        font-size: 14px;
        margin-left: 12px;
        cursor: pointer;
    }
    .bg-btn{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 16px 2px rgba(46,113,196,0.52);
        color: #4E9EF9;
    }
    .bottom-company-info{
        box-sizing: border-box;
        margin-top: 13px;
        padding: 20px;
        width:410px;
        height:390px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 27px 0px rgba(132,132,132,0.14);
        .hader-top{
            color: #59657A;
            font-size: 16px;
            font-weight: bold;
            position: relative;
            margin-left: 9px;
        }
        ul{
            margin-left: 9px;
            margin-top: 12px;
            li{
                color: #7D8DA4;
                font-size: 14px;
                margin-bottom: 8px;
            }
            .dian{
                display: inline-block;
                width:5px;
                height:5px;
                background:rgba(62,134,242,1);
                border-radius:50%;
                margin-right: 9px;
                vertical-align: 2px;
            }
        }
    }
    .info-right{
        float: left;
        margin-left: 13px;
        width:380px;
        height:564px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 27px 0px rgba(132,132,132,0.14);
        padding-top: 20px;
        box-sizing: border-box;
        position: relative;
        .hader-top{
            background: #ECF1F9;
            line-height: 36px;
            margin-top: 15px;
            span{
                display: inline-block;
                width: 23.33%;
                padding-left: 20px;
                box-sizing: border-box;
                font-size: 14px;
                font-weight: 500;
                color: #7D8DA4;
            }
        }
        .data-info{
            .data-info-li{
                background: #fff;
                color: #7D8DA4;
                font-size: 14px;
                span{
                    display: inline-block;
                    width: 23.33%;
                    padding: 14px 0 14px 20px;
                    box-sizing: border-box;
                    font-size: 14px;
                    font-weight: 500;
                    color: #7D8DA4;
                    vertical-align: top;
                }
            }
            .data-info-li:nth-child(2n){
                background: #F8F8F8;
            }
        }
        .btn-download{
            position: absolute;
            bottom: 0;
            line-height: 33px;
            color: #fff;
            font-size: 14px;
            width: 100%;
            text-align: center;
            background: rgba(0,0,0,0.36);
            cursor: pointer;
        }
    }
    .seamless-warp {
        height: 430px;
        overflow: hidden;
    }
    .bottm-back{
        position: relative;
        height: 200px;
        .bottom-back-img{
            width: 100%;
            position: absolute;
            bottom: 0;
            z-index: -1;
        }
    }
    .hader-top:before{
        content:" ";
        position: absolute;
        width: 3px;
        height: 14px;
        border-radius: 2px;
        background: #3E86F2;
        left: -9px;
        top: 4px;
    }
    .h3-title-top:before{
        content: " ";
        position: absolute;
        width:26px;
        height:3px;
        background:rgba(62,134,242,1);
        border-radius:2px;
        bottom: 0px;
        left: 192px;
    }
    .h3-title-tops:before{
        content: " ";
        position: absolute;
        width:26px;
        height:3px;
        background:rgba(62,134,242,1);
        border-radius:2px;
        bottom: 0px;
        left: 179px;
    }
}
</style>